import { action, makeObservable, observable } from 'mobx';

import { GAME_SPEED_TYPES, QUICK_BETS_COUNT_BY_PAGE } from '../core/constants/gameConstants';

class BettingPartStore {
  selectedQuickBet = 10;

  selectedQuickBetIndex = 0;

  defaultBetAmount = null;

  defaultBetAmountIndex = 0;

  quickBets = [];

  selectedQuickBetPage = 1;

  isShowQuickBetsListPopup = false;

  isOpenAutoBetPopup = false;

  gameSpeedType = GAME_SPEED_TYPES.standard;

  quickBetsByPage = [];

  quickBetsPaginationList = [];

  selectedAutoBetCount = null;

  isAutoBetStart = false;

  constructor() {
    makeObservable(this, {
      quickBets: observable,
      gameSpeedType: observable,
      isAutoBetStart: observable,
      quickBetsByPage: observable,
      defaultBetAmount: observable,
      selectedQuickBet: observable,
      isOpenAutoBetPopup: observable,
      selectedQuickBetPage: observable,
      selectedAutoBetCount: observable,
      selectedQuickBetIndex: observable,
      defaultBetAmountIndex: observable,
      quickBetsPaginationList: observable,
      isShowQuickBetsListPopup: observable,
      setQuickBets: action.bound,
      setGameSpeedType: action.bound,
      setIsAutoBetStart: action.bound,
      setQuickBetsByPage: action.bound,
      setDefaultBetAmount: action.bound,
      setSelectedQuickBet: action.bound,
      updateSelectedQuickBet: action.bound,
      setIsOpenAutoBetPopup: action.bound,
      setSelectedAutoBetCount: action.bound,
      setSelectedQuickBetPage: action.bound,
      setSelectedQuickBetIndex: action.bound,
      setDefaultBetAmountIndex: action.bound,
      setQuickBetsPaginationList: action.bound,
      setIsShowQuickBetsListPopup: action.bound,
      addFreeBetAmountToQuickBets: action.bound,
      deleteFreeBetAmountFromQuickBets: action.bound,
    });
  }

  setSelectedQuickBetIndex(index) {
    this.selectedQuickBetIndex = index;
  }

  setIsAutoBetStart(bool) {
    this.isAutoBetStart = bool;
  }

  setSelectedAutoBetCount(selectedAutoBetCount) {
    this.selectedAutoBetCount = selectedAutoBetCount;
  }

  setQuickBetsByPage(list) {
    if (list.length < QUICK_BETS_COUNT_BY_PAGE) {
      const lastList = [...this.quickBets].splice(
        QUICK_BETS_COUNT_BY_PAGE * (this.selectedQuickBetPage - 2),
        QUICK_BETS_COUNT_BY_PAGE
      );
      this.quickBetsByPage = [...lastList.slice(list.length - QUICK_BETS_COUNT_BY_PAGE), ...list];
    } else {
      this.quickBetsByPage = list;
    }
    this.setSelectedQuickBet(this.quickBetsByPage[0]);
  }

  setQuickBetsPaginationList(maxPageCount) {
    this.quickBetsPaginationList = new Array(maxPageCount).fill(null).map((el, index) => index + 1);
  }

  setSelectedQuickBetPage(page) {
    this.selectedQuickBetPage = page;
    this.setQuickBetsByPage(
      [...this.quickBets].splice(QUICK_BETS_COUNT_BY_PAGE * (page - 1), QUICK_BETS_COUNT_BY_PAGE)
    );
  }

  setSelectedQuickBet(selectedQuickBet) {
    this.selectedQuickBet = selectedQuickBet;
  }

  setDefaultBetAmount(defaultBetAmount) {
    this.defaultBetAmount = defaultBetAmount;
  }

  setDefaultBetAmountIndex(defaultBetAmountIndex) {
    this.defaultBetAmountIndex = defaultBetAmountIndex;
  }

  setQuickBets(quickBets) {
    this.quickBets = quickBets;
  }

  addFreeBetAmountToQuickBets(betAmount) {
    const newQuickBets = this.quickBets;
    if (!this.quickBets.some((el) => el === betAmount)) {
      this.isAddFreeBet = true;
      const newQuickFreeBets = newQuickBets.reduce((acc, current, index) => {
        if (current < betAmount && newQuickBets[index + 1] && newQuickBets[index + 1] > betAmount) {
          acc.push(current);
          acc.push(betAmount);
        } else {
          acc.push(current);
        }
        return acc;
      }, []);
      this.setQuickBets(newQuickFreeBets);
      this.updateSelectedQuickBet(betAmount);
    }
  }

  deleteFreeBetAmountFromQuickBets(betAmount) {
    if (this.isAddFreeBet) {
      this.quickBets = this.quickBets.filter((el) => el !== betAmount);
      this.setDefaultBetAmount(this.quickBets[0]);
      this.updateSelectedQuickBet(this.quickBets[0]);
      this.isAddFreeBet = false;
    }
  }

  updateSelectedQuickBet(defaultBetAmount) {
    const betAmountIndex = this.quickBets.findIndex((el) => el === +defaultBetAmount);
    this.setSelectedQuickBetIndex(betAmountIndex);
    this.setDefaultBetAmount(defaultBetAmount);
    this.setDefaultBetAmountIndex(betAmountIndex);
    this.setQuickBetsPaginationList(Math.ceil(this.quickBets.length / QUICK_BETS_COUNT_BY_PAGE));
    this.setSelectedQuickBetPage(Math.ceil((betAmountIndex + 1) / QUICK_BETS_COUNT_BY_PAGE) || 1);
    this.setSelectedQuickBet(defaultBetAmount);
  }

  setGameSpeedType(speedType) {
    this.gameSpeedType = speedType;
  }

  setIsShowQuickBetsListPopup(bool) {
    this.isShowQuickBetsListPopup = bool;
  }

  setIsOpenAutoBetPopup(bool) {
    this.isOpenAutoBetPopup = bool;
  }
}

export const bettingPartStore = new BettingPartStore();
